module.exports = __webpack_public_path__ + "img/shoulder.77cbef11.svg";